(function (module) {
    'use strict';

    function TrialExpiredCtrl(Store, $state, LoopBackAuth) {

        this.clearCookies = () => {
            Store.setCurrentSubAccountId(null);

            LoopBackAuth.clearUser();
            LoopBackAuth.clearStorage();
            $state.go('login');
        };

    }

    function TrialExpiredConfig($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider
            .state('root.trial-expired', {
                url: '/trial-expired',
                data: {
                    pageTitle: 'EXPIRED.PAGE_TITLE',
                },
                views: {
                    'content@root': {
                        templateUrl: '/js/authentication/trial-expired/trial-expired.html',
                        controller: 'TrialExpiredCtrl as $ctrl',
                    },
                },
                resolve: {
                    currentUser: function (User) {
                        return User.getCurrent().$promise.then(function (response) {
                            return response;
                        });
                    },
                    account: function (currentUser, Account, $state, utils) {
                        const accountId = currentUser.accountId;
                        Account.findById({id: accountId})
                            .$promise
                            .then(function (account) {
                                const {type, trialExpired} = utils.getAccountInfo(account);
                                console.log('type, trialExpired', type, trialExpired);
                                if (type === 'paid' || !trialExpired) {
                                    $state.go('root.home');
                                }
                            });
                    },
                },
                bodyClass: 'page--trialExpired',
            });

        $translatePartialLoaderProvider.addPart('/js/authentication/trial-expired');
    }

    module
        .config(TrialExpiredConfig)
        .controller('TrialExpiredCtrl', TrialExpiredCtrl);

})
(angular.module('rocket.components'));
